// Theniya Product Script - Conflict-Free Version
document.addEventListener('DOMContentLoaded', function() {
  const theniyaImageViewer = new TheniyaImageViewer();
  const theniyaTabs = new TheniyaTabs();
});

class TheniyaImageViewer {
  constructor() {
    this.currentImageIndex = 0;
    this.images = window.theniyaProductData ? window.theniyaProductData.images : [];
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateImageCounter();
  }

  bindEvents() {
    // Thumbnail clicks
    const thumbnails = document.querySelectorAll('.theniya-thumb');
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        this.switchToImage(index);
      });
    });

    // Navigation arrows
    const prevBtn = document.getElementById('TheniyaPrevBtn');
    const nextBtn = document.getElementById('TheniyaNextBtn');
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        this.previousImage();
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        this.nextImage();
      });
    }

    // Zoom functionality
    const zoomBtn = document.getElementById('TheniyaZoomBtn');
    const mainImage = document.getElementById('TheniyaMainImage');
    const zoomModal = document.getElementById('TheniyaZoomModal');
    const zoomClose = document.getElementById('TheniyaZoomClose');
    
    if (zoomBtn && zoomModal) {
      zoomBtn.addEventListener('click', () => {
        this.openZoom();
      });
      
      if (mainImage) {
        mainImage.addEventListener('click', () => {
          this.openZoom();
        });
      }
      
      if (zoomClose) {
        zoomClose.addEventListener('click', () => {
          this.closeZoom();
        });
      }
      
      zoomModal.addEventListener('click', (e) => {
        if (e.target === zoomModal) {
          this.closeZoom();
        }
      });
    }

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      const zoomModal = document.getElementById('TheniyaZoomModal');
      if (zoomModal && zoomModal.classList.contains('active')) {
        if (e.key === 'Escape') {
          this.closeZoom();
        } else if (e.key === 'ArrowLeft') {
          this.previousImage();
        } else if (e.key === 'ArrowRight') {
          this.nextImage();
        }
      }
    });

    // Touch/swipe support for mobile
    this.addTouchSupport();
  }

  switchToImage(index) {
    if (index < 0 || index >= this.images.length) return;
    
    this.currentImageIndex = index;
    const image = this.images[index];
    
    // Update main image
    const mainImage = document.getElementById('TheniyaMainImage');
    if (mainImage && image) {
      // Create image URLs for different sizes
      const imageUrl = image.src || image.url || '';
      let largeImageUrl, zoomImageUrl;
      
      if (imageUrl.includes('shopifycdn.com') || imageUrl.includes('cdn.shopify.com')) {
        // Shopify CDN - use proper transformations
        largeImageUrl = imageUrl.replace(/(_\d+x\d*)?(\.[^.]+)$/, '_800x800$2');
        zoomImageUrl = imageUrl.replace(/(_\d+x\d*)?(\.[^.]+)$/, '_1200x1200$2');
      } else {
        // Fallback for other URLs
        largeImageUrl = imageUrl;
        zoomImageUrl = imageUrl;
      }
      
      mainImage.src = largeImageUrl;
      mainImage.dataset.zoom = zoomImageUrl;
      mainImage.alt = image.alt || '';
    }
    
    // Update active thumbnail
    const thumbnails = document.querySelectorAll('.theniya-thumb');
    thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle('active', i === index);
    });
    
    // Update counter
    this.updateImageCounter();
    
    // Update zoom image if modal is open
    const zoomImage = document.getElementById('TheniyaZoomImage');
    const zoomModal = document.getElementById('TheniyaZoomModal');
    if (zoomImage && zoomModal && zoomModal.classList.contains('active')) {
      const imageUrl = image.src || image.url || '';
      let zoomImageUrl;
      
      if (imageUrl.includes('shopifycdn.com') || imageUrl.includes('cdn.shopify.com')) {
        zoomImageUrl = imageUrl.replace(/(_\d+x\d*)?(\.[^.]+)$/, '_1200x1200$2');
      } else {
        zoomImageUrl = imageUrl;
      }
      
      zoomImage.src = zoomImageUrl;
      zoomImage.alt = image.alt || '';
    }
  }

  previousImage() {
    const newIndex = this.currentImageIndex > 0 ? this.currentImageIndex - 1 : this.images.length - 1;
    this.switchToImage(newIndex);
  }

  nextImage() {
    const newIndex = this.currentImageIndex < this.images.length - 1 ? this.currentImageIndex + 1 : 0;
    this.switchToImage(newIndex);
  }

  updateImageCounter() {
    const counter = document.getElementById('TheniyaCurrentNum');
    if (counter) {
      counter.textContent = this.currentImageIndex + 1;
    }
  }

  openZoom() {
    const zoomModal = document.getElementById('TheniyaZoomModal');
    const zoomImage = document.getElementById('TheniyaZoomImage');
    const mainImage = document.getElementById('TheniyaMainImage');
    
    if (zoomModal && zoomImage && mainImage) {
      const zoomSrc = mainImage.dataset.zoom || mainImage.src;
      zoomImage.src = zoomSrc;
      zoomImage.alt = mainImage.alt;
      zoomModal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  closeZoom() {
    const zoomModal = document.getElementById('TheniyaZoomModal');
    if (zoomModal) {
      zoomModal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  addTouchSupport() {
    const mainImageContainer = document.querySelector('.theniya-image-container');
    if (!mainImageContainer) return;

    let startX = 0;
    let startY = 0;
    let isSwipe = false;

    mainImageContainer.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isSwipe = false;
    });

    mainImageContainer.addEventListener('touchmove', (e) => {
      if (!startX || !startY) return;
      
      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      
      const diffX = Math.abs(currentX - startX);
      const diffY = Math.abs(currentY - startY);
      
      if (diffX > diffY && diffX > 50) {
        isSwipe = true;
        e.preventDefault();
      }
    });

    mainImageContainer.addEventListener('touchend', (e) => {
      if (!isSwipe || !startX) return;
      
      const endX = e.changedTouches[0].clientX;
      const diffX = startX - endX;
      
      if (Math.abs(diffX) > 50) {
        if (diffX > 0) {
          this.nextImage();
        } else {
          this.previousImage();
        }
      }
      
      startX = 0;
      startY = 0;
      isSwipe = false;
    });
  }
}

class TheniyaTabs {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    const tabs = document.querySelectorAll('.theniya-tab');
    const panels = document.querySelectorAll('.theniya-tab-panel');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetTab = tab.getAttribute('data-tab');
        
        // Remove active class from all tabs and panels
        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));
        
        // Add active class to clicked tab and corresponding panel
        tab.classList.add('active');
        const targetPanel = document.getElementById(`tab-${targetTab}`);
        if (targetPanel) {
          targetPanel.classList.add('active');
        }
      });
    });

    // External link tracking
    const externalLinks = document.querySelectorAll('.btn--external');
    externalLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        const platform = link.classList.contains('btn--amazon') ? 'Amazon' : 'Etsy';
        
        // Google Analytics tracking (if available)
        if (typeof gtag !== 'undefined') {
          gtag('event', 'click', {
            event_category: 'External Shopping',
            event_label: platform,
            value: 1
          });
        }
        
        // Console log for debugging
        console.log(`User clicked ${platform} link for product`);
      });
    });
  }
}

// Initialize product form functionality if Shopify's option selectors are available
if (typeof Shopify !== 'undefined' && Shopify.OptionSelectors) {
  document.addEventListener('DOMContentLoaded', function() {
    new Shopify.OptionSelectors('ProductSelect', {
      product: window.theniyaProductData ? window.theniyaProductData.product : null,
      onVariantSelected: function(variant, selector) {
        const addToCartBtn = document.getElementById('AddToCart');
        const addToCartText = document.getElementById('AddToCartText');
        
        if (variant) {
          if (variant.available) {
            addToCartBtn.disabled = false;
            addToCartText.innerHTML = 'Add to Cart';
          } else {
            addToCartBtn.disabled = true;
            addToCartText.innerHTML = 'Sold Out';
          }

          // Update main image if variant has a featured image
          if (variant.featured_image && window.theniyaProductData) {
            const imageViewer = document.querySelector('.theniya-image-viewer');
            if (imageViewer) {
              const imageIndex = window.theniyaProductData.images.findIndex(img => img.id === variant.featured_image.id);
              if (imageIndex >= 0) {
                const viewerInstance = new TheniyaImageViewer();
                viewerInstance.switchToImage(imageIndex);
              }
            }
          }
        } else {
          addToCartBtn.disabled = true;
          addToCartText.innerHTML = 'Unavailable';
        }
      },
      enableHistoryState: true
    });
  });
}

